import React from "react";
import "../GalleryComponent/GalleryComponentCss/PayasbhutSection.css";

// Import all images shown in screenshot
import img1 from "../Images/payas1.jpg";   // top left big
import img2 from "../Images/payas2.jpg";   // top middle
import img3 from "../Images/payas3.jpg";   // top right
import img4 from "../Images/payas4.jpg";   // bottom left big
import img5 from "../Images/payas5.jpg";   // bottom middle
// import img6 from "../Images/payas6.jpg";   // bottom right

export default function PayasbhutSection() {
  return (
    <section className="payas-section">
      <h2 className="payas-title">पायाभूत सुविधा रस्ते शाळा अंगणवाडी</h2>

      <div className="payas-layout">

        {/* TOP LEFT BIG IMAGE */}
        <div className="payas-item payas-item1">
          <img src={img1} alt="" />
        </div>

        {/* TOP MIDDLE */}
        <div className="payas-item payas-item2">
          <img src={img2} alt="" />
        </div>

        {/* TOP RIGHT */}
        <div className="payas-item payas-item3">
          <img src={img3} alt="" />
        </div>

        {/* BOTTOM LEFT BIG */}
        <div className="payas-item payas-item4">
          <img src={img4} alt="" />
        </div>

        {/* BOTTOM MIDDLE */}
        <div className="payas-item payas-item5">
          <img src={img5} alt="" />
        </div>

        {/* BOTTOM RIGHT */}
        {/* <div className="payas-item payas-item6">
          <img src={img6} alt="" />
        </div> */}

      </div>
    </section>
  );
}
